import { createCrudThunks } from "./utils/thunk";
import { createCrudReducer } from "./utils/reducer";

import api from "./Tag/api";

const label = "Tag";
const entidade = "tags";

export const { get, add, update, deletar } = createCrudThunks(entidade, api, label);
const TagReducer = createCrudReducer(entidade, { get, add, update, deletar });

export {
  get as getTags,
  add as addNewTag,
  update as updateTag,
  deletar as deleteTag,
};

export default TagReducer;
